import React, { useState } from 'react';
import { Container, Row, Col, Card, Accordion } from 'react-bootstrap';
import { BookOpen, Code, History, Settings, Trash2, CheckCircle } from 'lucide-react';

const UserGuide = () => {
    // Theme state (Optional: Dashboard ke saath match karne ke liye)
    const [theme] = useState(localStorage.getItem('appTheme') || 'light');

    return (
        <Container fluid className={`py-4 py-md-5 ${theme === 'dark' ? 'bg-dark text-white' : 'bg-white'}`} style={{ maxWidth: '900px' }}>
            {/* Header Section: Mobile par font size chhota kiya gaya hai */}
            <div className="text-center mb-4 mb-md-5 px-2">
                <h2 className="fw-bold d-flex align-items-center justify-content-center text-primary flex-wrap" style={{ fontSize: 'calc(1.3rem + 1vw)' }}>
                    <BookOpen size={window.innerWidth < 768 ? 28 : 36} className="me-2 me-md-3 mb-2 mb-md-0" /> 
                    AI Code Reviewer - User Guide
                </h2>
                <p className="text-muted small px-3">Follow this guide to optimize your code and identify bugs effectively.</p>
            </div>

            <Row className="g-3 g-md-4 px-2">
                {/* Section 1: Manual Input & Voice */}
                <Col xs={12}>
                    <Card className={`border-0 shadow-sm p-3 p-md-4 ${theme === 'dark' ? 'bg-black text-white border border-secondary' : ''}`}>
                        <h5 className="fw-bold mb-3 d-flex align-items-center text-primary">
                            <Code size={20} className="me-2" /> 1. How to Request a Review?
                        </h5>
                        <p className="small">You can initiate a code review using two convenient methods:</p>
                        <ul className="list-unstyled ps-1 ps-md-3 small">
                            <li className="mb-2 d-flex align-items-start">
                                <CheckCircle size={14} className="me-2 mt-1 text-success flex-shrink-0"/> 
                                <span><strong>Manual Input:</strong> Paste your source code into the central search bar and click "Send".</span>
                            </li>
                            <li className="mb-2 d-flex align-items-start">
                                <CheckCircle size={14} className="me-2 mt-1 text-success flex-shrink-0"/> 
                                <span><strong>Voice Command:</strong> Click the Microphone icon to speak your queries or describe your logic.</span>
                            </li>
                        </ul>
                    </Card>
                </Col>

                {/* Section 2: AI Analysis */}
                <Col xs={12}>
                    <Card className={`border-0 shadow-sm p-3 p-md-4 ${theme === 'dark' ? 'bg-black text-white border border-secondary' : ''}`}>
                        <h5 className="fw-bold mb-3 d-flex align-items-center text-info">
                            <History size={20} className="me-2" /> 2. Understanding the AI Analysis
                        </h5>
                        <p className="small">The AI provides a report covering three key areas:</p>
                        <Accordion defaultActiveKey="0" className="mt-2 small">
                            <Accordion.Item eventKey="0" className={theme === 'dark' ? 'bg-dark text-white border-secondary' : ''}>
                                <Accordion.Header>🛠️ Code Overview</Accordion.Header>
                                <Accordion.Body className="small py-2">Summarizes the logic and functionality of your code structure.</Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1" className={theme === 'dark' ? 'bg-dark text-white border-secondary' : ''}>
                                <Accordion.Header>🔍 Potential Bugs</Accordion.Header>
                                <Accordion.Body className="small py-2">Identifies syntax errors, logical flaws, and security edge cases.</Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2" className={theme === 'dark' ? 'bg-dark text-white border-secondary' : ''}>
                                <Accordion.Header>🚀 Optimized Code</Accordion.Header>
                                <Accordion.Body className="small py-2">Provides refactored code with improved performance and best practices.</Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Card>
                </Col>

                {/* Section 3: Account Settings */}
                <Col xs={12}>
                    <Card className={`border-0 shadow-sm p-3 p-md-4 ${theme === 'dark' ? 'bg-black text-white border border-secondary' : ''}`}>
                        <h5 className="fw-bold mb-3 d-flex align-items-center text-warning">
                            <Settings size={20} className="me-2" /> 3. Account & Personalization
                        </h5>
                        <ul className="list-unstyled ps-1 ps-md-3 small">
                            <li className="mb-2 d-flex align-items-start">
                                <CheckCircle size={14} className="me-2 mt-1 text-warning flex-shrink-0"/> 
                                <span><strong>Themes:</strong> Switch between "Dark" and "Light" mode via profile dropdown.</span>
                            </li>
                            <li className="mb-2 d-flex align-items-start">
                                <CheckCircle size={14} className="me-2 mt-1 text-warning flex-shrink-0"/> 
                                <span><strong>Security:</strong> Permanently delete your account and history from settings.</span>
                            </li>
                        </ul>
                    </Card>
                </Col>

                {/* Section 4: History Management */}
                <Col xs={12}>
                    <Card className={`border-0 shadow-sm p-3 p-md-4 ${theme === 'dark' ? 'bg-black border border-secondary' : 'bg-light'}`}>
                        <h5 className="fw-bold mb-3 d-flex align-items-center text-danger">
                            <Trash2 size={20} className="me-2" /> 4. Managing Your History
                        </h5>
                        <p className="small ps-1 ps-md-3">Your previous reviews are stored in the <strong>Left Sidebar</strong>. Click the Trash icon to delete specific records.</p>
                    </Card>
                </Col>
            </Row>

            <footer className="text-center mt-4 text-muted small border-top pt-3">
                Built for Developers. Indore, Madhya Pradesh.
            </footer>
        </Container>
    );
};

export default UserGuide;